/* istanbul ignore file */

// declarative file
export enum RegexEnum {
  PERSON = '^[\\wŸÀ-ÿ( )\'"`’\\-]+$',
  SERVICES = '^[\\wŸÀ-ÿ( )\'"`’\\-\\.\\(\\)\\[\\]\\{\\};:!]+$',
  LOCATION = '^[\\wŸÀ-ÿ( )\'"`,\\-\\.\\+\\[\\]\\/]+$',
  PHONE = '^[0-9\\-\\.\\+( )]+$',
  BIRTHDATE = '^([012][0-9]|3[01])\\/(0[0-9]|1[012])\\/([0-9]{4})$',
  BIRTHDATE_AFTER_1799 = '^[0-9]{2}\\/[0-9]{2}\\/(18|19|20)[0-9]{2}$',
  UUIDV4 = '^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
}
